import React, { useState, useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { handlePlaidCreateLinkToken, handlePlaidExchangePublicToken } from '../modules/PlaidManager';
import { Button } from '@material-ui/core';
import { config } from '../config';

export const PlaidReconnectButton = ({ itemId, onSuccess }) => {
    const [linkToken, setLinkToken] = useState(null);
    const [loading, setLoading] = useState(false);

    const { open, ready } = usePlaidLink({
        token: linkToken,
        onSuccess: async (public_token, metadata) => {
            // Handle potential token exchange if Plaid returns a new public_token
            // This can happen in some edge cases during UPDATE_MODE
            if (public_token && public_token !== 'null' && public_token !== '') {
                try {
                    await handlePlaidExchangePublicToken(public_token);
                } catch (e) {
                    // Token exchange not needed for most UPDATE_MODE flows - this is expected
                }
            }
            
            // Update the database status to mark item as healthy
            try {
                const token = sessionStorage.getItem('token');
                await fetch(`${config.remoteUrl}/plaid/update_item_status`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({ item_id: itemId, status: 'good' })
                });
            } catch (error) {
                // Log error but still proceed with refresh
            }
            
            setLoading(false);
            onSuccess && onSuccess();
        },
        onExit: (err) => {
            if (err) {
                alert('Connection was not completed. Please try again or contact support.');
            }
            setLoading(false);
        },
    });

    const handleReconnect = async () => {
        setLoading(true);
        try {
            // Pass itemId to backend - server looks up access_token securely
            const response = await handlePlaidCreateLinkToken(itemId);
            if (response.status === 'success' && response.data.link_token) {
                setLinkToken(response.data.link_token);
                // Open will be called automatically when ready changes
            } else {
                throw new Error('Failed to get link token');
            }
        } catch (error) {
            alert('Failed to initialize reconnection. Please try again.');
            setLoading(false);
        }
    };

    // Auto-open when ready
    useEffect(() => {
        if (ready && linkToken) {
            open();
        }
    }, [ready, linkToken, open]);

    return (
        <Button
            onClick={handleReconnect}
            disabled={loading}
            style={{
                backgroundColor: config.colors.pageButtons,
                color: config.colors.pageButtonsText,
            }}
        >
            {loading ? 'Loading...' : 'Reconnect Account'}
        </Button>
    );
};
